// extracted by mini-css-extract-plugin
module.exports = {"icon-info":"Icon-Icon-icon-info-1hEzyhzy","iconInfo":"Icon-Icon-icon-info-1hEzyhzy"};